(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/input-range/assets/javascripts/input-range-track-fill.js') >= 0) return;  svs.modules.push('/components/lb-ui/input-range/assets/javascripts/input-range-track-fill.js');

'use strict';

const InputRangeTrackFill = _ref => {
  let {
    scale,
    startPos
  } = _ref;
  const size = Math.max(0, Math.min(1, scale));
  return React.createElement("div", {
    className: "input-range-bar",
    "data-testid": "qa-input-range-bar"
  }, React.createElement("div", {
    className: "input-range-fill",
    "data-testid": "qa-input-range-fill",
    style: {
      transform: "translateX(".concat(startPos, "px) scaleX(").concat(size, ")")
    }
  }));
};
setGlobal('svs.components.lbUi.inputRange.InputRangeTrackFill', InputRangeTrackFill);

 })(window);